import { render, staticRenderFns } from "./CreditorAccountStatements.vue?vue&type=template&id=6211ed9a&scoped=true"
import script from "./CreditorAccountStatements.vue?vue&type=script&lang=js"
export * from "./CreditorAccountStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6211ed9a",
  null
  
)

export default component.exports